function getInstanceConfig(
  configObject,
  fallbackKey = 'community_lab',
  filterFn
) {
  const instance = process.env.NEXT_PUBLIC_INSTANCE_NAME || fallbackKey
  let config = configObject[instance] || configObject[fallbackKey]

  if (filterFn && Array.isArray(config)) {
    config = config.filter(filterFn)
  }

  return config
}

module.exports = getInstanceConfig
